import axios from 'axios'
import { getHost } from './host'

export interface Schedule {
  id: number;
  station_id: number;
  schedules_id: number | null;
  category: string;
  status: number;
  created?: string;
  updated?: string;
  account_id: number;
  title: string,
  description: string;
  freq: string;
  dtstart: string;
  duration: number;
  wskt: null | number;
  interval: number;
  count: null | number;
  until: null | string;
  bysteppos: null | number[];
  bymonth: null | number[];
  bymonthday: null | number[];
  byyearday: null | number[];
  byeaster: null | number[];
  byweekno: null | number[];
  byweekday: null | number[];
  byhour: null | number[];
  byminute: null | number[];
  bysecond: null | number[];
}

export interface CreateSchedule {
  schedules_id: number;
  status: number;
  title: string;
  description: string;
  freq: string;
  dtstart: string;
  duration: number;
  interval: number;
  byweekday: null | number[];
  byhour: null | number[];
  byminute: null | number[];
}

// const endPoint = 'api/power';
const endPoint = 'api/rules';

export async function getSchedules(api_key: string, stations: number[], category) {
  const url = `https://${getHost()}/${endPoint}/schedules`
  
  const params = {
    stations: stations,
    category: category
  }

  const { data } = await axios.get<Schedule[]>(url, { headers: {'X-API-KEY': api_key, Accept: 'application/json'}, params: params });
  return data
}

export async function saveSchedule(api_key: string, account_id=null, schedule: CreateSchedule) {
  var url = `https://${getHost()}/${endPoint}/schedule`

  const bodyFormData = new FormData();
  
  if (schedule.schedules_id !== null) {
    url = `https://${getHost()}/${endPoint}/schedule/` + schedule.schedules_id.toString();
  }
  bodyFormData.append('status', schedule.status.toString());
  bodyFormData.append('title', schedule.title.toString());
  bodyFormData.append('description', schedule.description.toString());
  bodyFormData.append('freq', schedule.freq.toString());
  bodyFormData.append('dtstart', schedule.dtstart.toString());
  bodyFormData.append('duration', schedule.duration.toString());
  bodyFormData.append('interval', schedule.interval.toString());
  bodyFormData.append('byweekday', JSON.stringify(schedule.byweekday));
  bodyFormData.append('byhour', JSON.stringify(schedule.byhour));
  bodyFormData.append('byminute', JSON.stringify(schedule.byminute));
  bodyFormData.append('trigger_owasys_refresh', 'true');
  if (account_id !== null) {
    bodyFormData.append('account_id', account_id);
  }
  
  const headers = {
    'X-API-KEY': api_key, Accept: 'application/json'
  };

  const { data } = await axios.post<Schedule>(url, bodyFormData, { headers: headers });
  
  return data
}

export async function attachStations(api_key: string, station_ids: number[], schedule_id: number, category: string) {
  const url = `https://${getHost()}/${endPoint}/attach`
  
  const bodyFormData = new FormData();

  station_ids.forEach((station_id) => {
      bodyFormData.append('stations[]', station_id.toString());
  });
  
  bodyFormData.append('category', 'power');
  bodyFormData.append('schedule_id', schedule_id.toString());
  bodyFormData.append('trigger_owasys_refresh', 'true');
  bodyFormData.append('category', category);
  
  const headers = {
    'X-API-KEY': api_key, Accept: 'application/json'
  };

  const { data } = await axios.post<any[]>(url, bodyFormData, { headers: headers });
  
  return data
}

export async function detachStations(api_key: string, station_ids: number[], schedule_id: number, category: string) {
  const url = `https://${getHost()}/${endPoint}/detach`

  const bodyFormData = new FormData();

  station_ids.forEach((station_id) => {
      bodyFormData.append('stations[]', station_id.toString());
  });
  
  bodyFormData.append('schedule_id', schedule_id.toString());
  bodyFormData.append('trigger_owasys_refresh', 'true');
  bodyFormData.append('category', category);
  
  const headers = {
    'X-API-KEY': api_key, Accept: 'application/json'
  };

  const { data } = await axios.post<any[]>(url, bodyFormData, { headers: headers });
  
  return data
}